module.exports = "/assets/data/8b85d5ef065950a58b379b3d0df5c029-L12.data.json";